import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import { Select, Store } from '@ngxs/store';
import {Observable} from 'rxjs';
import { AuthState } from '../states/auth/auth.state';
import { PharmacyState } from '../states/pharmacy/pharmacy.state';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  @Select(PharmacyState.currentPharmacy) currentPharmacy$: Observable<any>;

  pharmacyId: string | null = null;

  constructor(private store: Store) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let pharmacyId = this.store.selectSnapshot(AuthState.pharmacyId);
    if (pharmacyId) {
      req = req.clone({setHeaders: {PharmacyID: pharmacyId}});
    }
    return next.handle(req);
  }
}
